// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lp-landing-page-ai-course-skills{background:#f2f5f7}", "",{"version":3,"sources":["webpack://./src/features/learnEngine/private/components/LandingPage/AICourseSkills/AICourseSkills.scss"],"names":[],"mappings":"AAAA,kCACC,kBAAA","sourcesContent":[".lp-landing-page-ai-course-skills {\n\tbackground: #F2F5F7;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
